import { FC } from "react";
import { Button } from "@mantine/core";

interface FileUploadButtonProps {
  userId: string;
  onUpload: (
    userId: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

const FileUploadButton: FC<FileUploadButtonProps> = ({ userId, onUpload }) => (
  <>
    <input
      type="file"
      id={`file-upload-${userId}`}
      accept="image/*,application/pdf"
      multiple
      onChange={(e) => onUpload(userId, e)}
      style={{ display: "none" }}
    />
    <Button
      onClick={() => document.getElementById(`file-upload-${userId}`)?.click()}
      variant="filled"
      color="blue"
      size="sm"
    >
      Upload
    </Button>
  </>
);

export default FileUploadButton;
